import { useCallback } from 'react';
import { notification } from 'antd';
import { getFirestore } from '../config';

export default function useAddUserToCompany() {
  return useCallback(async (companyId, data) => {
    try {
      await getFirestore()
        .collection('companies')
        .doc(companyId)
        .update({
          ...data,
        });
    } catch (e) {
      console.log(e);
      notification.error({ message: e.message });
    }
  }, []);
}
